import "./Blob10.scss";
import blobVideo from "../video/blob_10.mp4";

function Blob10() {

    return (
        <div className={'container-animation-10 blob-10'}>
            <video autoPlay loop muted playsInline>
                <source src={blobVideo} type="video/mp4"/>
            </video>
        </div>
    );
}

export default Blob10;
